let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("qq3t5")).then(() => parcelRequire('fh3pW'));